import moment from "moment";
import "moment-timezone";
import React from "react";
import { formats } from "../../../variables/variables";

const AvailabilityExceptions = ({ availabilityExceptions, remove, style = {} }) => {
  return (
    <div style={{ ...{minWidth:800}, ...style }}>
      <h4>
        Availability Overrides
      </h4>
      {availabilityExceptions.length === 0 ? (
        <p>nothing to see here</p>
      ) : (
        <table className="table table-condensed table-zebra">
          <thead>
            <tr>
              <th style={{ width: 400 }}>Dates</th>
              <th style={{ width: 200 }}>Work Hours</th>
              <th style={{ minWidth: 200 }}>Description</th>
            </tr>
          </thead>
          <tbody>
            {availabilityExceptions.map((aex, index) => {
              const fromDate = aex.date;
              const toDate = aex.date_to || aex.date;
              return (
                <tr key={aex.id}>
                  <td>
                    <span
                      className="text-danger"
                      style={{ cursor: "pointer", marginRight: 10 }}
                      onClick={() => {
                        remove(index);
                      }}
                    >
                      <i className="far fa-times-circle"></i>
                    </span>
                    <span>
                      {moment(fromDate).format(formats.shortDateYear)}
                      {fromDate !== toDate && (
                        <> to {moment(toDate).format(formats.shortDateYear)}</>
                      )}
                    </span>
                  </td>
                  <td>
                    {aex.available.map((av, index) => (
                      <span style={{ marginRight: 20 }} key={aex}>
                        {av.from}-{av.to}
                      </span>
                    ))}
                    {aex.available.length === 0 && (
                      <span style={{ color: "#888" }}>not working</span>
                    )}
                  </td>
                  <td>{aex.description || "-"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AvailabilityExceptions;